import bulkUserImportExample from "assets/images/bulkUserImportExample.png";
import theme from "assets/theme";
import React, { useCallback, useEffect, useState } from "react";
import { Image, StyleSheet, Text, View } from "react-native";
import { readString } from "react-native-csv";
import CSVFileUpload from "webComponentsFormElements/inputs/CSVFileUpload.component";

const classes = StyleSheet.create({
  root: {
    gap: 4,
  },
  text: {
    color: theme.color.darkGrey,
  },
  image: {
    width: "100%",
    aspectRatio: 6,
  },
  listContainer: {
    gap: 2,
    paddingLeft: 20,
  },
  listItem: {
    marginBottom: 2,
  },
  listItemText: {
    color: theme.color.darkGrey,
  },
  noteText: {
    fontSize: theme.font.size.small,
    color: theme.color.backgroundText,
    fontStyle: "italic",
    marginTop: 1,
    paddingLeft: 24,
  },
  warningText: {
    fontSize: theme.font.size.small,
    color: theme.color.darkGrey,
    fontWeight: theme.font.weight.semibold,
    marginTop: 1,
    paddingLeft: 24,
  },
});

export default function ImportUsersForm(props) {
  const [file, setFile] = useState(null);
  const { setCanSave, setUsersData, usersData } = props;
  const handleInputFile = useCallback(
    // eslint-disable-next-line no-shadow
    (file) => {
      if (!file) {
        return;
      }

      const reader = new FileReader();

      reader.onload = (event) => {
        const csvString = event.target.result.replace(/\r\n/g, "\n").trim();
        const result = readString(csvString, {
          header: true,
          delimiter: ",",
          skipEmptyLines: true,
        });

        if (result.errors?.length) {
          console.warn("CSV Parse Errors:", result.errors);
        }

        setUsersData(result.data);
      };

      reader.readAsText(file);
    },
    [setUsersData],
  );

  useEffect(() => {
    if (usersData.length) {
      setCanSave(true);
    }
  }, [usersData, setCanSave]);

  return (
    <View style={classes.root}>
      <Text style={classes.text}>
        This .csv can contain any of the columns below, identified by their
        heading names. All other column types will be ignored.
      </Text>
      <Text style={classes.text}>
        Do not create a team named "Team 'abbreviation'", i.e. "Team NCG", a
        default team is automatically created for each organization with each
        user added to it by default and this format will interfere with the
        expected outcome.
      </Text>
      <Text style={classes.text}>Example of CSV structure:</Text>
      <Image source={bulkUserImportExample} resizeMode="contain" style={classes.image} />
      <Text style={classes.text}>
        For best results, rename the column headers of the .csv to match the
        naming below.
      </Text>
      <View style={classes.listContainer}>
        {[
          { field: "First Name" },
          { field: "Last Name" },
          { field: "Title" },
          { field: "Email" },
          { field: "Cell Phone" },
          {
            field: "Team(s)",
            note: "*Enter as a comma-separated list for multiple teams.",
            warning:
              "NOTE: The Person will be linked to all Teams that are in the Team(s) column. New Teams in the Team(s) column will be created.",
          },
          {
            field: "Place(s)",
            note: "*Enter as a comma-separated list for multiple places.",
            warning:
              "NOTE: The Person will be linked to all Places that are in the Place(s) column. New Places in the Place(s) column will be created.",
          },
        ].map((item, index) => (
          <View key={index} style={classes.listItem}>
            <Text style={classes.listItemText}>• {item.field}</Text>
            {item.note && <Text style={classes.noteText}>{item.note}</Text>}
            {item.warning && (
              <Text style={classes.warningText}>{item.warning}</Text>
            )}
          </View>
        ))}
      </View>
      <CSVFileUpload
        setFile={setFile}
        setFileBlob={handleInputFile}
        file={file}
      />
    </View>
  );
}
